export const mixins = {
    data() {
        return {
            api: this.$store.getters.api || undefined,
            user: this.$store.getters.user,
            development: false,
            production: false,
            test: false
        };
    },
    created: function () {
        switch (process.env.VUE_APP_MODE) {
            case ('development'): {
                this.development = true;
                break;
            }
            case ('test'): {
                this.test = true;
                break;
            }
            case ('production'): {
                this.production = true;
            }
        }
        this.user = this.$store.getters.user
    },
    beforeUpdate: function () {
        this.user = this.$store.getters.user
    },
    methods: {
        hasRole: function (testRole) {
            if (this.user.roles.find(o => o.role === testRole)) {
                return true;
            } else {
                return false;
            }
        },
        errorToast: function (message) {
            this.$bvToast.toast(message, {
                title: 'ERROR',
                autoHideDelay: 5000,
                appendToast: false,
                variant: "danger",
                toaster: "b-toaster-top-center"
            })
        },
        successToast: function (message) {
            this.$bvToast.toast(message, {
                title: 'Success',
                autoHideDelay: 2000,
                appendToast: false,
                variant: "success",
                toaster: "b-toaster-top-center"
            })
        },
        infoToast: function (message) {
            this.$bvToast.toast(message, {
                title: 'Informational',
                autoHideDelay: 3500,
                appendToast: false,
                variant: "info",
                toaster: "b-toaster-top-center"
            })
        },
    }
}
